var _defs, _rect, _text, _rect2, _text2, _rect3, _rect4, _rect5, _line, _line2, _line3, _g, _g2, _g3, _circle, _circle2, _circle3, _g4, _g5, _g6, _text3, _text4, _text5, _text6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg7Workers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 260",
    xmlns: "http://www.w3.org/2000/svg",
    width: 700,
    height: 260,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n    @keyframes w-pulse{0%,100%{opacity:.6;transform:scale(1)}50%{opacity:1;transform:scale(1.05)}}\n    @keyframes w-send{0%{offset-distance:0%;opacity:0}10%{opacity:1}90%{opacity:1}100%{offset-distance:100%;opacity:0}}\n    @keyframes phone-arrive{0%,70%{stroke:#1e293b}80%,95%{stroke:#34d399}100%{stroke:#1e293b}}\n    .w1{animation:w-pulse 2s ease-in-out infinite 0s;transform-origin:180px 80px}\n    .w2{animation:w-pulse 2s ease-in-out infinite .6s;transform-origin:180px 140px}\n    .w3{animation:w-pulse 2s ease-in-out infinite 1.2s;transform-origin:180px 200px}\n    .ph1{animation:phone-arrive 2s ease-in-out infinite 1s}\n    .ph2{animation:phone-arrive 2s ease-in-out infinite 1.6s}\n    .ph3{animation:phone-arrive 2s ease-in-out infinite 2.2s}\n  "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#060912"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#06100c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w-worker",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0c2a1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0a1628"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w-glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "b"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "wpath1",
    d: "M 240 80 Q 380 80 460 80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wpath2",
    d: "M 240 140 Q 380 140 460 140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wpath3",
    d: "M 240 200 Q 380 200 460 200"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 700,
    height: 260,
    fill: "url(#w-bg)",
    rx: 20
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 26,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 10,
    letterSpacing: 2
  }, "PARALLEL WORKERS \u2014 PROCESSING AND DELIVERING")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 100,
    width: 110,
    height: 80,
    rx: 10,
    fill: "#0a0f1e",
    stroke: "#1e293b",
    strokeWidth: 1.5
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 125,
    textAnchor: "middle",
    fill: "#334155",
    fontFamily: "JetBrains Mono",
    fontSize: 9
  }, "QUEUE")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 132,
    width: 80,
    height: 12,
    rx: 4,
    fill: "#0d2247",
    stroke: "#3b82f6",
    strokeWidth: 0.8,
    opacity: 0.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 150,
    width: 80,
    height: 12,
    rx: 4,
    fill: "#0d2247",
    stroke: "#7c3aed",
    strokeWidth: 0.8,
    opacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 168,
    width: 80,
    height: 12,
    rx: 4,
    fill: "#0d2247",
    stroke: "#059669",
    strokeWidth: 0.8,
    opacity: 0.3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 130,
    x2: 155,
    y2: 80,
    stroke: "#1e293b",
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 140,
    x2: 155,
    y2: 140,
    stroke: "#1e293b",
    strokeWidth: 1.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 150,
    x2: 155,
    y2: 200,
    stroke: "#1e293b",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "w1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 56,
    width: 85,
    height: 48,
    rx: 10,
    fill: "url(#w-worker)",
    stroke: "#34d399",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 197,
    y: 76,
    textAnchor: "middle",
    fill: "#34d399",
    fontFamily: "JetBrains Mono",
    fontSize: 10
  }, "\u26A1"), /*#__PURE__*/React.createElement("text", {
    x: 197,
    y: 90,
    textAnchor: "middle",
    fill: "#34d399",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "Worker 1"), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 96,
    width: 75,
    height: 4,
    rx: 2,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 96,
    width: 55,
    height: 4,
    rx: 2,
    fill: "#34d399",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "10;75;10",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0s"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "w2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 116,
    width: 85,
    height: 48,
    rx: 10,
    fill: "url(#w-worker)",
    stroke: "#38bdf8",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 197,
    y: 136,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontFamily: "JetBrains Mono",
    fontSize: 10
  }, "\u26A1"), /*#__PURE__*/React.createElement("text", {
    x: 197,
    y: 150,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "Worker 2"), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 156,
    width: 75,
    height: 4,
    rx: 2,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 156,
    width: 40,
    height: 4,
    rx: 2,
    fill: "#38bdf8",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "10;75;10",
    dur: "2s",
    repeatCount: "indefinite",
    begin: ".6s"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "w3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 176,
    width: 85,
    height: 48,
    rx: 10,
    fill: "url(#w-worker)",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 197,
    y: 196,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontFamily: "JetBrains Mono",
    fontSize: 10
  }, "\u26A1"), /*#__PURE__*/React.createElement("text", {
    x: 197,
    y: 210,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontFamily: "JetBrains Mono",
    fontSize: 8
  }, "Worker 3"), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 216,
    width: 75,
    height: 4,
    rx: 2,
    fill: "#1e293b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 216,
    width: 65,
    height: 4,
    rx: 2,
    fill: "#a78bfa",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "width",
    values: "10;75;10",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.2s"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#34d399",
    filter: "url(#w-glow)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "0s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#wpath1"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "0s"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#38bdf8",
    filter: "url(#w-glow)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: ".6s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#wpath2"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: ".6s"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#a78bfa",
    filter: "url(#w-glow)"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "1.2s"
  }, /*#__PURE__*/React.createElement("mpath", {
    href: "#wpath3"
  })), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;1;1;0",
    dur: "1.8s",
    repeatCount: "indefinite",
    begin: "1.2s"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "ph1",
    x: 462,
    y: 58,
    width: 44,
    height: 76,
    rx: 8,
    fill: "#0a1628",
    stroke: "#1e293b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 68,
    width: 28,
    height: 44,
    rx: 3,
    fill: "#060912"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 484,
    cy: 124,
    r: 4,
    fill: "#0f172a",
    stroke: "#1e293b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 72,
    width: 16,
    height: 2,
    rx: 1,
    fill: "#1e293b",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0;1;1;0",
    keyTimes: "0;.5;.6;.7;.9;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 77,
    width: 22,
    height: 1.5,
    rx: 0.75,
    fill: "#1e293b",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0;1;1;0",
    keyTimes: "0;.5;.6;.7;.9;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "ph2",
    x: 462,
    y: 118,
    width: 44,
    height: 76,
    rx: 8,
    fill: "#0a1628",
    stroke: "#1e293b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 128,
    width: 28,
    height: 44,
    rx: 3,
    fill: "#060912"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 484,
    cy: 184,
    r: 4,
    fill: "#0f172a",
    stroke: "#1e293b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 132,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#1e293b",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0;1;1;0",
    keyTimes: "0;.5;.6;.7;.9;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.6s"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 137,
    width: 22,
    height: 1.5,
    rx: 0.75,
    fill: "#1e293b",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0;1;1;0",
    keyTimes: "0;.5;.6;.7;.9;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.6s"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "ph3",
    x: 462,
    y: 178,
    width: 44,
    height: 76,
    rx: 8,
    fill: "#0a1628",
    stroke: "#1e293b",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 188,
    width: 28,
    height: 44,
    rx: 3,
    fill: "#060912"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 484,
    cy: 244,
    r: 4,
    fill: "#0f172a",
    stroke: "#1e293b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 192,
    width: 20,
    height: 2,
    rx: 1,
    fill: "#1e293b",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0;1;1;0",
    keyTimes: "0;.5;.6;.7;.9;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "2.2s"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 473,
    y: 197,
    width: 22,
    height: 1.5,
    rx: 0.75,
    fill: "#1e293b",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0;1;1;0",
    keyTimes: "0;.5;.6;.7;.9;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "2.2s"
  })))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 100,
    fill: "#34d399",
    fontFamily: "JetBrains Mono",
    fontSize: 9,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0;1;1;0",
    keyTimes: "0;.5;.65;.75;.9;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1s"
  }), "\u2713 Sent")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 162,
    fill: "#38bdf8",
    fontFamily: "JetBrains Mono",
    fontSize: 9,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0;1;1;0",
    keyTimes: "0;.5;.65;.75;.9;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.6s"
  }), "\u2713 Sent")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 222,
    fill: "#a78bfa",
    fontFamily: "JetBrains Mono",
    fontSize: 9,
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0;0;0;1;1;0",
    keyTimes: "0;.5;.65;.75;.9;1",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "2.2s"
  }), "\u2713 Sent")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 350,
    y: 238,
    textAnchor: "middle",
    fill: "#1e293b",
    fontFamily: "JetBrains Mono",
    fontSize: 9
  }, "Three workers process in parallel \u2014 notifications delivered simultaneously")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg7Workers);
export default __webpack_public_path__ + "static/media/svg7-workers.90ddc6188ea3b20835e874b43991712f.svg";
export { ForwardRef as ReactComponent };